import React from 'react';

interface NavProps {
  className?: string;
  children?: React.ReactNode;
}

function NavBase({ className = '', children }: NavProps) {
  return <nav className={`nav flex flex-wrap ${className}`.trim()}>{children}</nav>;
}

interface ItemProps {
  className?: string;
  children?: React.ReactNode;
}

function NavItem({ className = '', children }: ItemProps) {
  return <div className={`nav-item ${className}`.trim()}>{children}</div>;
}

const Nav = Object.assign(NavBase, {
  Item: NavItem,
});

export default Nav;
